'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _themes = require('../themes'),
    componentTheme = function componentTheme(baseTheme) {
  var _Mathround = Math.round,
      _baseTheme$vstui = baseTheme.vstui,
      color = _baseTheme$vstui.color,
      rem = _baseTheme$vstui.rem,
      shape = _baseTheme$vstui.shape,
      size = _baseTheme$vstui.size,
      transition = _baseTheme$vstui.transition,
      typography = _baseTheme$vstui.typography,
      primaryMain = function primaryMain(_ref) {
    var sc = _ref.sc;
    return color.primary.getMainShade({
      backgroundColor: sc.colorBehindButton
    });
  },
      primaryDarker = function primaryDarker(_ref2) {
    var sc = _ref2.sc;
    return color.primary.getMainShade({
      backgroundColor: sc.colorBehindButton,
      offset: 1
    });
  },
      primaryDarkest = function primaryDarkest(_ref3) {
    var sc = _ref3.sc;
    return color.primary.getMainShade({
      backgroundColor: sc.colorBehindButton,
      offset: 2
    });
  },
      secondaryMain = function secondaryMain(_ref4) {
    var sc = _ref4.sc;
    return color.secondary.getMainShade({
      backgroundColor: sc.colorBehindButton
    });
  },
      secondaryDarker = function secondaryDarker(_ref5) {
    var sc = _ref5.sc;
    return color.secondary.getMainShade({
      backgroundColor: sc.colorBehindButton,
      offset: 1
    });
  },
      secondaryDarkest = function secondaryDarkest(_ref6) {
    var sc = _ref6.sc;
    return color.secondary.getMainShade({
      backgroundColor: sc.colorBehindButton,
      offset: 2
    });
  },
      cloud3 = color.cloud.getShade(3),
      cloud4 = color.cloud.getShade(4),
      ninja9 = color.ninja.getShade(9),
      black43 = 'rgba(0, 0, 0, 0.43)',
      backgroundColor_disabled = color.transparent,
      backgroundColor_naked = color.transparent,
      borderColor_disabled = 'rgba(0, 0, 0, 0.20)',
      borderColor_naked = color.transparent,
      color_disabled = color.black,
      white80 = 'rgba(255, 255, 255, 0.8)';

  return (0, _themes.createComponentTheme)(baseTheme, {
    Button_backgroundColor_themePrimary: primaryMain,
    Button_backgroundColor_themePrimary_disabled: backgroundColor_disabled,
    Button_backgroundColor_themePrimary_active: primaryDarker,
    Button_backgroundColor_themePrimary_focus: primaryDarker,
    Button_backgroundColor_themePrimary_hover: primaryDarker,
    Button_backgroundColor_themePrimaryNaked: backgroundColor_naked,
    Button_backgroundColor_themePrimaryNaked_disabled: backgroundColor_naked,
    Button_backgroundColor_themePrimaryNaked_active: backgroundColor_naked,
    Button_backgroundColor_themePrimaryNaked_focus: backgroundColor_naked,
    Button_backgroundColor_themePrimaryNaked_hover: backgroundColor_naked,
    Button_backgroundColor_themeSecondary: secondaryMain,
    Button_backgroundColor_themeSecondary_disabled: backgroundColor_disabled,
    Button_backgroundColor_themeSecondary_active: secondaryDarker,
    Button_backgroundColor_themeSecondary_focus: secondaryDarker,
    Button_backgroundColor_themeSecondary_hover: secondaryDarker,
    Button_backgroundColor_themeSecondaryNaked: backgroundColor_naked,
    Button_backgroundColor_themeSecondaryNaked_disabled: backgroundColor_naked,
    Button_backgroundColor_themeSecondaryNaked_active: backgroundColor_naked,
    Button_backgroundColor_themeSecondaryNaked_focus: backgroundColor_naked,
    Button_backgroundColor_themeSecondaryNaked_hover: backgroundColor_naked,
    Button_backgroundColor_neutral: cloud3,
    Button_backgroundColor_neutral_disabled: backgroundColor_disabled,
    Button_backgroundColor_neutral_active: cloud4,
    Button_backgroundColor_neutral_focus: cloud4,
    Button_backgroundColor_neutral_hover: cloud4,
    Button_backgroundColor_neutralNaked: backgroundColor_naked,
    Button_backgroundColor_neutralNaked_disabled: backgroundColor_naked,
    Button_backgroundColor_neutralNaked_active: backgroundColor_naked,
    Button_backgroundColor_neutralNaked_focus: backgroundColor_naked,
    Button_backgroundColor_neutralNaked_hover: backgroundColor_naked,
    Button_backgroundColor_white: color.surface,
    Button_backgroundColor_white_disabled: backgroundColor_disabled,
    Button_backgroundColor_white_active: white80,
    Button_backgroundColor_white_focus: white80,
    Button_backgroundColor_white_hover: white80,
    Button_backgroundColor_whiteNaked: backgroundColor_naked,
    Button_backgroundColor_whiteNaked_disabled: backgroundColor_naked,
    Button_backgroundColor_whiteNaked_active: backgroundColor_naked,
    Button_backgroundColor_whiteNaked_focus: backgroundColor_naked,
    Button_backgroundColor_whiteNaked_hover: backgroundColor_naked,
    Button_borderColor_themePrimary: primaryMain,
    Button_borderColor_themePrimary_disabled: borderColor_disabled,
    Button_borderColor_themePrimary_active: primaryDarker,
    Button_borderColor_themePrimary_focus: primaryDarker,
    Button_borderColor_themePrimary_hover: primaryDarker,
    Button_borderColor_themePrimaryNaked: borderColor_naked,
    Button_borderColor_themePrimaryNaked_disabled: borderColor_naked,
    Button_borderColor_themePrimaryNaked_active: borderColor_naked,
    Button_borderColor_themePrimaryNaked_focus: borderColor_naked,
    Button_borderColor_themePrimaryNaked_hover: borderColor_naked,
    Button_borderColor_themeSecondary: secondaryMain,
    Button_borderColor_themeSecondary_disabled: borderColor_disabled,
    Button_borderColor_themeSecondary_active: secondaryDarker,
    Button_borderColor_themeSecondary_focus: secondaryDarker,
    Button_borderColor_themeSecondary_hover: secondaryDarker,
    Button_borderColor_themeSecondaryNaked: borderColor_naked,
    Button_borderColor_themeSecondaryNaked_disabled: borderColor_naked,
    Button_borderColor_themeSecondaryNaked_active: borderColor_naked,
    Button_borderColor_themeSecondaryNaked_focus: borderColor_naked,
    Button_borderColor_themeSecondaryNaked_hover: borderColor_naked,
    Button_borderColor_neutral: black43,
    Button_borderColor_neutral_disabled: borderColor_disabled,
    Button_borderColor_neutral_active: black43,
    Button_borderColor_neutral_focus: black43,
    Button_borderColor_neutral_hover: black43,
    Button_borderColor_neutralNaked: borderColor_naked,
    Button_borderColor_neutralNaked_disabled: borderColor_naked,
    Button_borderColor_neutralNaked_active: borderColor_naked,
    Button_borderColor_neutralNaked_focus: borderColor_naked,
    Button_borderColor_neutralNaked_hover: borderColor_naked,
    Button_borderColor_white: color.surface,
    Button_borderColor_white_disabled: color.surface,
    Button_borderColor_white_active: white80,
    Button_borderColor_white_focus: white80,
    Button_borderColor_white_hover: white80,
    Button_borderColor_whiteNaked: borderColor_naked,
    Button_borderColor_whiteNaked_disabled: borderColor_naked,
    Button_borderColor_whiteNaked_active: borderColor_naked,
    Button_borderColor_whiteNaked_focus: borderColor_naked,
    Button_borderColor_whiteNaked_hover: borderColor_naked,
    Button_borderRadius: shape.borderRadius,
    Button_borderStyle: shape.borderStyle,
    Button_borderWidth: shape.borderWidth,
    Button_boxShadow_themePrimary_focus: function Button_boxShadow_themePrimary_focus(props) {
      return '0 0 0 2px ' + color.onPrimary + ', 0 0 0 4px ' + primaryDarker(props);
    },
    Button_boxShadow_themePrimaryNaked_focus: function Button_boxShadow_themePrimaryNaked_focus(props) {
      return '0 0 0 2px ' + primaryDarker(props);
    },
    Button_boxShadow_themeSecondary_focus: function Button_boxShadow_themeSecondary_focus(props) {
      return '0 0 0 2px ' + color.onSecondary + ', 0 0 0 4px ' + secondaryDarker(props);
    },
    Button_boxShadow_themeSecondaryNaked_focus: function Button_boxShadow_themeSecondaryNaked_focus(props) {
      return '0 0 0 2px ' + secondaryDarker(props);
    },
    Button_boxShadow_neutral_focus: '0 0 0 2px ' + color.surface + ', 0 0 0 4px ' + black43,
    Button_boxShadow_neutralNaked_focus: '0 0 0 2px ' + black43,
    Button_boxShadow_white_focus: function Button_boxShadow_white_focus(_ref7) {
      var sc = _ref7.sc;
      return '0 0 0 2px ' + (sc.colorBehindButton || color.black) + ', 0 0 0 4px ' + white80;
    },
    Button_boxShadow_whiteNaked_focus: '0 0 0 2px ' + white80,
    Button_fontFamily: typography.fontFamily,
    Button_fontSize_small: typography.fontSize - 2,
    Button_fontSize_medium: typography.fontSize,
    Button_fontSize_large: typography.fontSize + 4,
    Button_fontSize_inline: 'inherit',
    Button_fontWeight_themePrimary: typography.fontWeightMedium,
    Button_fontWeight_themeSecondary: typography.fontWeightMedium,
    Button_fontWeight_neutral: typography.fontWeightRegular,
    Button_fontWeight_white: typography.fontWeightMedium,
    Button_fontWeight_naked: typography.fontWeightMedium,
    Button_fontWeight_disabled: typography.fontWeightLight,
    Button_minHeight_small: size.small,
    Button_minHeight_medium: size.medium,
    Button_minHeight_large: size.large,
    Button_textDecoration: 'none',
    Button_textDecoration_inline: 'underline',
    Button_color_themePrimary: color.onPrimary,
    Button_color_themePrimary_disabled: color_disabled,
    Button_color_themePrimary_active: color.onPrimary,
    Button_color_themePrimary_focus: color.onPrimary,
    Button_color_themePrimary_hover: color.onPrimary,
    Button_color_themePrimaryNaked: primaryDarker,
    Button_color_themePrimaryNaked_disabled: color_disabled,
    Button_color_themePrimaryNaked_active: primaryDarkest,
    Button_color_themePrimaryNaked_focus: primaryDarkest,
    Button_color_themePrimaryNaked_hover: primaryDarkest,
    Button_color_themeSecondary: color.onSecondary,
    Button_color_themeSecondary_disabled: color_disabled,
    Button_color_themeSecondary_active: color.onSecondary,
    Button_color_themeSecondary_focus: color.onSecondary,
    Button_color_themeSecondary_hover: color.onSecondary,
    Button_color_themeSecondaryNaked: secondaryDarker,
    Button_color_themeSecondaryNaked_disabled: color_disabled,
    Button_color_themeSecondaryNaked_active: secondaryDarkest,
    Button_color_themeSecondaryNaked_focus: secondaryDarkest,
    Button_color_themeSecondaryNaked_hover: secondaryDarkest,
    Button_color_neutral: color.black,
    Button_color_neutral_disabled: color_disabled,
    Button_color_neutral_active: color.black,
    Button_color_neutral_focus: color.black,
    Button_color_neutral_hover: color.black,
    Button_color_neutralNaked: color.black,
    Button_color_neutralNaked_disabled: color_disabled,
    Button_color_neutralNaked_active: ninja9,
    Button_color_neutralNaked_focus: ninja9,
    Button_color_neutralNaked_hover: ninja9,
    Button_color_white: function Button_color_white(_ref8) {
      var sc = _ref8.sc;
      return sc.colorBehindButton || color.black;
    },
    Button_color_white_disabled: color.surface,
    Button_color_white_active: function Button_color_white_active(_ref9) {
      var sc = _ref9.sc;
      return sc.colorBehindButton || color.black;
    },
    Button_color_white_focus: function Button_color_white_focus(_ref10) {
      var sc = _ref10.sc;
      return sc.colorBehindButton || color.black;
    },
    Button_color_white_hover: function Button_color_white_hover(_ref11) {
      var sc = _ref11.sc;
      return sc.colorBehindButton || color.black;
    },
    Button_color_whiteNaked: color.surface,
    Button_color_whiteNaked_disabled: color.surface,
    Button_color_whiteNaked_active: white80,
    Button_color_whiteNaked_focus: white80,
    Button_color_whiteNaked_hover: white80,
    Button_paddingHorizontal_small: _Mathround(size.small * (2 / 3)) + 'px',
    Button_paddingHorizontal_medium: _Mathround(size.medium * (2 / 3)) + 'px',
    Button_paddingHorizontal_large: _Mathround(size.large * (2 / 3)) + 'px',
    Button_paddingHorizontal_fullWidth: '' + rem(typography.fontSize - 2),
    Button_paddingHorizontal_withIconSmall: '' + rem(typography.fontSize - 2),
    Button_paddingHorizontal_withIconMedium: '' + rem(typography.fontSize),
    Button_paddingHorizontal_withIconLarge: '' + rem(typography.fontSize),
    Button_transitionDuration: transition.duration.shortest,
    Button_transitionEasing: transition.easing.easeIn,
    ButtonContent_justifyContent: 'center',
    ButtonIcon_fill_disabled: 'rgba(0, 0, 0, 0.3)'
  });
};

exports.default = componentTheme;